import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import BlogCard from './BlogCard';

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
}

interface BlogSectionProps {
  title: string;
  subtitle: string;
  posts: BlogPost[];
  limit?: number;
}

const BlogSection: React.FC<BlogSectionProps> = ({
  title,
  subtitle,
  posts,
  limit = 3,
}) => {
  // Limit posts
  const displayedPosts = posts.slice(0, limit);
  
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-sm font-medium mb-4">
            Our Blog
          </span>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-gray-900">{title}</h2>
          <p className="md:text-lg text-gray-600">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayedPosts.map((post) => (
            <BlogCard
              key={post.id}
              id={post.id}
              title={post.title}
              excerpt={post.excerpt}
              category={post.category}
              date={post.date}
              author={post.author}
              imageUrl={post.imageUrl}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/blog" 
            className="inline-flex items-center px-6 py-3 border border-gray-300 rounded-lg text-blue-600 bg-white hover:bg-gray-50 font-medium transition duration-300"
          >
            View All Articles
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;